import script from "./BannerCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./BannerCarousel.vue?vue&type=style&index=0&id=78c7d45a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/api2-production/workspace/api2/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c7d45a"]])

export default __exports__